import { useCallback } from "react";
import useAjax from "@apis/useAjax";
import { GET_EMPLOYEE_QRCODE_API } from "@apis/apiPath";

const useEmployeeTokenApi = () => {
    const Ajax = useAjax();

    const getEmployeeQrcodeApi = useCallback(
        async employeeID => await Ajax.get(GET_EMPLOYEE_QRCODE_API(employeeID)),
        // eslint-disable-next-line
        []
    );
    
    return { 
        getEmployeeQrcodeApi 
    };
};

export default useEmployeeTokenApi;